/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_CostInputs */

const en_mk_sol_operasional_cost = /** @type {(inputs: Mk_Sol_Operasional_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twenty seats on the Business plan: Rp 3,980,000 a month, with exportable audit records and usage analytics.`)
};

const id_mk_sol_operasional_cost = /** @type {(inputs: Mk_Sol_Operasional_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua puluh kursi paket Bisnis: Rp 3.980.000 per bulan, dengan catatan audit yang bisa diekspor dan analitik pemakaian.`)
};

/**
* | output |
* | --- |
* | "Twenty seats on the Business plan: Rp 3,980,000 a month, with exportable audit records and usage analytics." |
*
* @param {Mk_Sol_Operasional_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_cost = /** @type {((inputs?: Mk_Sol_Operasional_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_cost(inputs)
	return en_mk_sol_operasional_cost(inputs)
});